import React from 'react';
import { connect } from 'react-redux';
import { find, isEqual, capitalize, cloneDeep, get, map } from 'lodash';
import Box from '../../common/Box';
import vendorsArray from '../../widgets/filter/enums/vendors';
import ReactTable from 'react-table';
import ModeSelect from '../../common/ModeSelect';
import CSV from '../../../helpers/CSVExport';
import ReactSelect from '../../common/ReactSelect';
import LineChart from '../../widgets/charts/types/LineChart';
import DoughnutChart from '../../widgets/charts/types/DoughnutChart';
import LineChartWithAnnotations from '../../widgets/charts/types/LineChartWithAnnotations';

import { youtubeActions } from '../../../data/actions/youtube';
import { youtubeTracksSettings } from './YoutubeTracks/Settings';

var downloadSvg = require('!svg-inline-loader!../../../../public/img/download.svg');
var lineSvg = require('!svg-inline-loader!../../../../public/img/line.svg');
var tableSvg = require('!svg-inline-loader!../../../../public/img/table.svg');


class YoutubeTracks extends React.Component {
	
	constructor(props) {
		super(props);
		this.state = {
			mode: 'table',
	        vendor: 0,
	        pieTracks: 'views',
			sorted: [{id: 'total', desc: true}]
		}
		this.exportToCsv = this.exportToCsv.bind(this);
		this.setVendor = this.setVendor.bind(this);
		this.setChartMode = this.setChartMode.bind(this);
		this.setPieTracks = this.setPieTracks.bind(this);
	}

    exportToCsv(){
        const {tracks} = this.props.youtube,
            filename = CSV.CSVHeader('youtube_tracks', '', this.props.filter.global);
        
        return CSV.CSVExport(tracks, {filename}, 'youtube_tracks');
    }
    
    setVendor({vend_id}) {
        this.setState({
            vendor: vend_id
        });
    }
    
    setPieTracks({value}) {
        this.setState({
            pieTracks: value
        });
    }
	
	setChartMode(mode){
		this.setState({mode});
		
		const { modeChange } = this.props;
		if(typeof modeChange == 'function')
			modeChange(mode);
			
		if(mode == 'line') {
			this.props.getYoutubeTracksTimeseries(this.props.filtered, this.state.sorted, this.state.dateGroup);
		}
	}

	renderToolbar(data){
		const options = [
			{icon: tableSvg, value: 'table', label: "Table Chart"},
			{icon: lineSvg, value: 'line', label: "Line Chart"},
		];

		let toolbar = [];
		toolbar.push(<div key="wrapper" className="ibox-action-holder">
		<div className="ibox-actions">
			<div className="ibox-icon-holder mode-select">
				<ModeSelect options={options} selected={this.state.mode} onChange={this.setChartMode} isSearchable={ false } />
			</div>
            <a key="download" title="Export CSV" onClick={this.exportToCsv} className="download-link" dangerouslySetInnerHTML={{__html: downloadSvg}} />
		</div>
		</div>)

		return toolbar;
	}

	
   renderToolbarPie(data = []){
        let toolbar = [];
        let vendors = [{label:'Views', value: 'views'}, {label:'Creates', value: 'creates'}];

        const vendorValue = vendors.find(vendor=>vendor.value == this.state.pieTracks);
		
		
		const options = [
			{icon: pieSvg, value: 'pie', label: "Donut Chart"},
			{icon: lineSvg, value: 'line', label: "Line Chart"},
			{icon: tableSvg, value: 'table', label: "Table"},
			
		];
		toolbar.push(<div key="wrapper" className="ibox-action-wrapper">
			<div className="ibox-icon-holder mode-select">
				<ModeSelect options={options} selected={this.state.mode} onChange={this.setChartMode} isSearchable={ false } />
			</div>
        	<div className="ibox-actions">
            	<ReactSelect value={vendorValue} options={vendors} onChange={this.setPieTracks} className="single-select"/>
        	</div>
        </div>)

        return toolbar;
    }

	
	
	componentDidMount() {
		const { mode } = this.state;
		if(mode == 'line')
			this.props.getYoutubeTracksTimeseries(this.props.filtered, this.state.sorted);
		else
			this.props.getYoutubeTracks(this.props.filtered, this.state.sorted);
	}
	
	componentWillReceiveProps(nextProps){
		const { mode } = this.state;
		if(nextProps.filter && nextProps.filter.global){
			if(this.props.filter.global!==undefined && !isEqual(nextProps.filter.global, this.props.filter.global)) {
				if(mode == 'line')
					this.props.getYoutubeTracksTimeseries(nextProps.filtered, this.state.sorted);
				else
					this.props.getYoutubeTracks(nextProps.filtered, this.state.sorted);
			}                
		}
		if(nextProps.filtered && !isEqual(nextProps.filtered, this.props.filtered)) {
			if(mode == 'line')
				this.props.getYoutubeTracksTimeseries(nextProps.filtered, this.state.sorted);
			else
				this.props.getYoutubeTracks(nextProps.filtered, this.state.sorted);
		} 
	}
	
	render (){  
		const {tracks: tracks, tracksLoading: tracksLoading, tracksTimeseries, tracksTimeseriesLoading} = this.props.youtube,
			widgetTitle = `Top YouTube Tracks`;
		const { vendor, pieTracks, mode } = this.state;
		let { shadowChartProps } = this.props;
		if(shadowChartProps){
			shadowChartProps.shadowChart = true;
		}    
		let tableData = [], pieLabels = [], pieDataset = [], vendors = [], pie = {};
		let milestonesItems = get(this.props.milestones, 'entities.mixed.tableItems', [])
		
		return <React.Fragment>
    		<Box title={widgetTitle} toolbar={this.renderToolbar(vendors)} spinnerEnabled={tracksLoading || tracksTimeseriesLoading } >
                {(tracks && mode == 'table' ) && <ReactTable
                    className="simple-table"
                    data={tracks}
                    columns={youtubeTracksSettings.settingsForTable()}
                    showPagination={false}
                    defaultSortDesc={true}
                	defaultSorted={this.state.sorted}
                    pageSize={(tracks && tracks.length ) ? tracks.length : 10}                
                />}
				{(tracksTimeseries && mode == 'line' ) && <div className="chart-block">
					<LineChartWithAnnotations milestones={milestonesItems} data={tracksTimeseries} shadowChartProps={shadowChartProps}  filteredLogVendors={['youtube']} />
				</div>}
    		</Box>
		</React.Fragment>;
	}
}

function mapStateToProps(state) {
	return {
		youtube: state.youtube,
		filter: state.filter,
		milestones: state.milestones
	} 
}

function mapDispatchToProps(dispatch, ownProps) {
	return {
		getYoutubeTracks: (filtered, sorted, dateGroup) => {
			return dispatch(youtubeActions.getTopTracksStats(filtered, sorted, dateGroup));
		} ,
		getYoutubeTracksTimeseries: (filtered, sorted, dateGroup) => {
			return dispatch(youtubeActions.getTopTracksTimeseries(filtered, sorted, dateGroup));
		} 
	} 
}



export default connect(mapStateToProps, mapDispatchToProps)(YoutubeTracks);